// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';

// material ui
import { alpha, Chip } from '@mui/material';
import { purple } from '@mui/material/colors';

// relative
import EnergyXplorerBaseCard from './EnergyXplorerBaseCard';

const AlarmCard = ({ index = 0 }) => {
  const { t } = useTranslation('energy-analysis');
  const features = t('sales_cards.alarms.features', {
    returnObjects: true,
  });
  const card = {
    title: t('sales_cards.alarms.title'),
    subtitle: t('sales_cards.alarms.subtitle'),
    description: t('sales_cards.alarms.description'),
    icon: <InsightsRoundedIcon sx={{ fontSize: 40 }} />,
    color: purple[300],
    bgColor: alpha(purple[300], 0.1),
    features: Array.isArray(features) ? features : [],
    learnMoreLink: null,
    contactLink: null,
    chip: (
      <Chip
        label={t('sales_cards.coming_soon')}
        sx={{
          fontWeight: 600,
          letterSpacing: '0.02em',
          borderRadius: 1,
          backgroundColor: (theme) => alpha(theme.palette.remoni[700], 0.1), // secondary main, low opacity
          borderColor: (theme) => theme.palette.remoni[700],
        }}
      />
    ),
  };

  return <EnergyXplorerBaseCard card={card} index={index} />;
};

export default AlarmCard;
